import { Component, EventEmitter, Input, Output} from '@angular/core';
import { TransactionViewModel } from './transaction-history.page';
import { PrinterService } from '../data/printer.service';

@Component({
    selector: 'app-transaction-history-item[transaction]',
    styles: [`
    :host {
      display: block;
    }
  `],
    template: `
    <app-transaction-history-item-header [transaction]="transaction" class="flex-grow-1 flex-shrink-0">
    </app-transaction-history-item-header>
    <section class="ps-3 pe-3 overflow-y-auto flex-grow-1 flex-shrink-1 h-100">
      <app-transaction-history-item-article *ngFor="let item of transaction?.items" [transactionItem]="item">
      </app-transaction-history-item-article>
    </section>
    <aside class="flex-grow-0 flex-shrink-0 d-flex justify-content-end m-4">
      <ng-container *ngIf="showPrintButton">
        <button
          *ngIf="!isSPOS"
          type="button"
          class="btn btn-lg me-2 mt-3 py-3 btn-info"
          [appLoadingOverlay]="printing"
          (click)="printReceipt()"
          i18n
        >
          <span class="d-flex align-items-center justify-content-center">
            <span class="material-icons me-1">print</span>
            <span>Beleg drucken</span>
          </span>
        </button>

        <ng-container *ngIf="isSPOS">
          <button type="button" class="btn btn-lg me-2 mt-3 py-3 btn-info" [appLoadingOverlay]="printing" (click)="printReceipt()">
            <span class="d-flex align-items-center justify-content-center">
              <span class="material-icons me-1">print</span>
              <span i18n>Kundenbeleg drucken</span>
            </span>
          </button>
          <button type="button" class="btn btn-lg py-3 me-2 mt-3 btn-info" [appLoadingOverlay]="printing" (click)="printReceipt(true)">
            <span class="d-flex align-items-center justify-content-center">
              <span class="material-icons me-1">print</span>
              <span i18n>Händlerbeleg drucken</span>
            </span>
          </button>
        </ng-container>
      </ng-container>

      <button
        class="btn btn-info btn-lg mt-3 text-white history-item-component-button"
        i18n
        [disabled]="allReturned"
        (click)="productReturns.emit(transaction)"
      >{{ allReturned ? 'Vollständig zurückgegeben' : 'Warenrücknahme' }}</button>
    </aside>
  `,
    standalone: false
})
export class HistoryItemComponent {
  @Input() transaction!: TransactionViewModel | null;
  @Input() allReturned: boolean = false;
  @Output() productReturns: EventEmitter<TransactionViewModel | null> = new EventEmitter<TransactionViewModel | null>();

  printing = false;

  constructor(public printerService: PrinterService) {}

  get showPrintButton() {
    const { receiptUrl, receiptImageUrl, receiptEposUrl } = this.transaction ?? {};

    return receiptUrl && receiptImageUrl && receiptEposUrl;
  }

  get isSPOS() {
    return this.transaction?.paymentType === 'versa_commerce_pos_spos';
  }

  printReceipt(isMerchant = false) {
    if (!this.transaction) {
      return;
    }

    this.printing = true;

    const { receiptUrl, receiptImageUrl, receiptEposUrl } = this.transaction;

    this.printerService.printReceipt(receiptUrl, receiptImageUrl, receiptEposUrl, isMerchant);

    this.printing = false;
  }
}
